<template>
  <div style="width: 100%; height: 100%; position: relative">
    <div
      class="content"
      :style="`height:${dispH - 60}px;width: 100%;`"
      style="
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        align-items: center;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 100;
      "
    >
      <div v-for="(item, index) in resData" :key="index" style="position: relative">
        <div style="font-size: 28px; height: 60px; line-height: 60px">
          {{ getTitile(item.title) }}
        </div>
        <ImageBoxPupil
          :src="item.src"
          :width="dispW * 0.6 * staticStyle.imagePupilWidth"
          :height="dispW * 0.6 * staticStyle.imagePupilWidth * (768 / 1024)"
          :focus="true"
          colorHex="#00ff00"
          :info="getInfo()"
          :proc="getProc()"
          :eyetype="currentEye"
          currentUnit="mm"
          :currentPhoto="''"
          curPage="pupilcorneadia"
          :edges="data2Imgbox[index]"
          :graphMode="graphMode"
        />
        <div
          :style="`width:${dispW * 0.6 * staticStyle.imagePupilWidth}px; height: ${
            dispW * 0.6 * staticStyle.imagePupilWidth * (768 / 1024)
          }px;position: absolute;top:60px;left:0;`"
        >
          <div style="position: relative; width: 100%; height: 100%">
            <div
              style="position: absolute; bottom: 0px; right: 0px; cursor: pointer"
              :style="`width: ${dispW * 0.6 * 0.45 * 0.1}px; height: ${dispW * 0.6 * 0.45 * 0.1}px`"
              @click="showlargeImage(item, index)"
            >
              <img src="../../assets/img/large.png" alt="" style="width: 100%" />
            </div>

            <div
              style="position: absolute; top: 0px; right: 0px; cursor: pointer"
              :style="`width: ${dispW * 0.6 * 0.45 * 0.1}px; height: ${dispW * 0.6 * 0.45 * 0.12}px`"
              @click="removePupil(item, index)"
            >
              <img src="../../assets/img/remove.png" alt="" style="width: 100%" />
            </div>
          </div>
        </div>

        <div
          v-if="coordinateSystem === 'rectangular'"
          style="font-size: 22px; height: 60px; line-height: 60px"
        >
          <div style="color: green">
            {{ $t("langcfg.txtPupilDia") }}: {{ item.diameter }} mm Kappa: (X={{ item.offsetx }} mm,
            Y={{ item.offsety }} mm)
          </div>
        </div>
        <div
          v-if="coordinateSystem === 'polar'"
          style="font-size: 22px; height: 60px; line-height: 60px"
        >
          <div style="color: green">
            {{ $t("langcfg.txtPupilDia") }}: {{ item.diameter }} mm Kappa: ({{ item.offsetR }} mm @
            {{ item.offsetAngle }}°)
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="isLarge"
      :style="`height:${dispH - 60}px;width: 100%;`"
      style="position: absolute; top: 0; left: 0; z-index: 900; background-color: #2d3039"
    >
      <div style="margin-left: 20px">
        <div style="font-size: 28px; height: 90px; line-height: 90px; position: relative">
          <div>{{ getTitile(largeData.data.title) }}</div>
          <div
            style="position: absolute; top: 0; left: 50px; width: 50px; cursor: pointer"
            @click="closeLargeImage"
          >
            <!-- <span class="iconfont icon-left bpl-fs" style="font-size: 30px"></span> -->
            <img src="../../assets/img/back .png" alt="" style="width: 100%; margin-top: 20px" />
          </div>
        </div>
        <ImageBoxPupil
          :src="largeData.data.src"
          :width="dispW * staticStyle.imageCorneaWidth - 20"
          :height="(dispW * staticStyle.imageCorneaWidth - 20) * (768 / 1024)"
          :focus="true"
          colorHex="#00ff00"
          :info="getInfo()"
          :proc="getProc()"
          :eyetype="currentEye"
          currentUnit="mm"
          :currentPhoto="''"
          curPage="pupilcorneadia"
          :edges="data2Imgbox[largeData.index]"
          @update="update"
          @init-drawtype="btnDrawToolChange"
          @edge-changed="onEdgeChanged"
          :graphMode="graphMode"
        />
      </div>
      <div
        class="footer"
        style="height: 100px; width: 100%; display: flex; justify-content: space-around"
      >
        <div
          style="
            height: 100%;
            width: 37%;
            display: flex;
            align-items: center;
            height: 100px;
            margin-left: 20px;
          "
        >
          <drawTypePupil
            SubPage="PupilCornea"
            :toolsBoxWidth="470"
            :toolsBoxHeight="100"
            v-model="graphMode"
            :pupilOrCornea="'pupil'"
            :title="largeData.data.title"
          />
        </div>
        <div style="font-size: 26px; width: 63%; height: 100px; display: flex; align-items: center">
          <div
            v-if="coordinateSystem === 'rectangular'"
            style="color: green; margin-top: 12px; width: 100%; height: 100%; line-height: 100px"
          >
            {{ $t("langcfg.txtPupilDia") }}: {{ largeData.data.diameter }} mm Kappa: (X={{
              largeData.data.offsetx
            }}
            mm, Y={{ largeData.data.offsety }} mm)
          </div>
          <div
            v-if="coordinateSystem === 'polar'"
            style="color: green; margin-top: 12px; width: 100%; height: 100%; line-height: 100px"
          >
            {{ $t("langcfg.txtPupilDia") }}: {{ largeData.data.diameter }} mm Kappa: ({{
              largeData.data.offsetR
            }}
            mm @ {{ largeData.data.offsetAngle }}°)
          </div>
        </div>
      </div>
    </div>

    <!-- 角膜直径 -->
    <div
      v-if="isCornea"
      :style="`height:${dispH - 60}px;width: 100%;`"
      style="position: absolute; top: 0; left: 0; z-index: 900; background-color: #2d3039"
    >
      <div style="margin-left: 20px">
        <div style="font-size: 28px; height: 90px; line-height: 90px; position: relative">
          <div>{{ this.$t("langcfg.txtCorneaDiam") }}</div>
        </div>
        <ImageBoxPupil
          :src="corneaCalData.src"
          :width="dispW * staticStyle.imageCorneaWidth - 20"
          :height="(dispW * staticStyle.imageCorneaWidth - 20) * (768 / 1024)"
          :focus="true"
          colorHex="#00ff00"
          :info="getInfo()"
          :proc="getProc()"
          :eyetype="currentEye"
          currentUnit="mm"
          :currentPhoto="''"
          curPage="cornea"
          :edges="corneaImgbox"
          @update="update"
          @init-drawtype="btnDrawToolChange"
          @edge-changed="onEdgeChanged"
          :graphMode="graphMode"
        />
      </div>
      <div
        class="footer"
        style="height: 100px; width: 100%; display: flex; justify-content: space-around"
      >
        <div
          style="
            height: 100%;
            width: 37%;
            display: flex;
            align-items: center;
            height: 100px;
            margin-left: 20px;
          "
        >
          <drawTypePupil
            SubPage="PupilCornea"
            :toolsBoxWidth="470"
            :toolsBoxHeight="100"
            v-model="graphMode"
            :pupilOrCornea="'cornea'"
            :title="corneaData.title"
          />
        </div>
        <div style="font-size: 26px; width: 63%; height: 100px; display: flex; align-items: center">
          <div
            v-if="coordinateSystem === 'rectangular'"
            style="color: yellow; margin-top: 12px; width: 100%; height: 100%; line-height: 100px"
          >
            {{ $t("langcfg.txtCorneaDiam") }}: {{ corneaCalData.diameter }} mm Alpha: (X={{
              corneaCalData.offsetx
            }}
            mm, Y={{ corneaCalData.offsety }} mm)
          </div>
          <div
            v-if="coordinateSystem === 'polar'"
            style="color: yellow; margin-top: 12px; width: 100%; height: 100%; line-height: 100px"
          >
            {{ $t("langcfg.txtCorneaDiam") }}: {{ corneaCalData.diameter }} mm Alpha: ({{
              corneaCalData.offsetR
            }}
            mm @ {{ corneaCalData.offsetAngle }}°)
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImageBoxPupil from "../../common/components/ImageBoxPupil.vue";
import drawTypePupil from "../../common/components/drawTypePupil.vue";
import { hasKey, isEqual, logStdout, objectCopy } from "../../shared/utils";

const mockData = [
  {
    title: "dark",
    diameter: 234.4453582763672 * 2,
    centerX: 1017.2806396484375,
    centerY: 812.9024658203125,
    ringX: 1027.2806396484375,
    ringY: 812.9024658203125
  },
  {
    title: "lowerMiddle",
    diameter: 234.4453582763672 * 2,
    centerX: 1017.2806396484375,
    centerY: 812.9024658203125,
    ringX: 1027.2806396484375,
    ringY: 812.9024658203125
  },
  {
    title: "middle",
    diameter: 234.4453582763672 * 2,
    centerX: 1017.2806396484375,
    centerY: 812.9024658203125,
    ringX: 1027.2806396484375,
    ringY: 812.9024658203125
  },
  {
    title: "bright",
    diameter: 234.4453582763672 * 2,
    centerX: 1017.2806396484375,
    centerY: 812.9024658203125,
    ringX: 1027.2806396484375,
    ringY: 812.9024658203125
  }
];

export default {
  name: "PupilCorneaStatic",
  components: {
    ImageBoxPupil,
    drawTypePupil
  },
  data: function () {
    return {
      // curImg: 'meibomian'
      staticStyle: {
        imagePupilWidth: window.copyScreen ? 0.4 : 0.47,
        imageCorneaWidth: window.copyScreen ? 0.52 : 0.6
      },
      largeData: {
        data: {},
        index: 0
      },
      corneaData: {
        title: ""
      },
      isLarge: false,
      isCornea: false,
      pupilImageData: [],
      corneaImageData: {}
    };
  },
  props: {
    dispW: Number,
    dispH: Number,
    currentMode: String,
    src: String,
    currentEye: String,
    graphMode: String,
    pupilStaticData: {
      type: Array,
      default: function () {
        return [];
      }
    },
    corneaStaticData: {
      type: Object,
      default: function () {
        return {};
      }
    },
    coordinateSystem: {
      type: String,
      default: "rectangular"
    }
  },
  computed: {
    data2Imgbox: function () {
      return this.pupilImageData.map((item) => {
        return {
          corneadia: {
            r: 0,
            x: 0,
            y: 0
          },
          pupildia: {
            r: item.diameter,
            x: item.centerX,
            y: item.centerY,
            rx: item.ringX,
            ry: item.ringY
          }
        };
      });
    },
    resData: function () {
      return this.pupilImageData.map((item) => {
        let offsetx =
          item.centerX === -1000 || item.ringX === -1000
            ? "--"
            : ((item.centerX - item.ringX) * window.magecoe.pupilcornea * 2).toFixed(2);
        let offsety =
          item.centerY === -1000 || item.ringY === -1000
            ? "--"
            : ((item.centerY - item.ringY) * window.magecoe.pupilcornea * 2).toFixed(2);
        return {
          title: item.title,
          diameter:
            item.diameter === -1000
              ? "--"
              : (item.diameter * window.magecoe.pupilcornea * 2).toFixed(2),
          offsetx: offsetx,
          offsety: offsety,
          src: item.media,
          offsetR: this.cartesianToPolar(offsetx, offsety).radius,
          offsetAngle: this.cartesianToPolar(offsetx, offsety).angleDegrees
        };
      });
    },
    corneaCalData: function () {
      let offsetx =
        this.corneaStaticData.centerX === -1000 || this.corneaStaticData.ringX === -1000
          ? "--"
          : (
              (this.corneaStaticData.centerX - this.corneaStaticData.ringX) *
              window.magecoe.pupilcornea *
              2
            ).toFixed(2);
      let offsety =
        this.corneaStaticData.centerY === -1000 || this.corneaStaticData.ringY === -1000
          ? "--"
          : (
              (this.corneaStaticData.centerY - this.corneaStaticData.ringY) *
              window.magecoe.pupilcornea *
              2
            ).toFixed(2);
      return {
        diameter:
          this.corneaStaticData.diameter === -1000
            ? "--"
            : (this.corneaStaticData.diameter * window.magecoe.pupilcornea * 2).toFixed(2),
        offsetx: offsetx,
        offsety: offsety,
        src: this.corneaStaticData.media,
        offsetR: this.cartesianToPolar(offsetx, offsety).radius,
        offsetAngle: this.cartesianToPolar(offsetx, offsety).angleDegrees
      };
    },
    corneaImgbox: function () {
      return {
        corneadia: {
          r: this.corneaStaticData.diameter,
          x: this.corneaStaticData.centerX,
          y: this.corneaStaticData.centerY,
          rx: this.corneaStaticData.ringX,
          ry: this.corneaStaticData.ringY
        },
        pupildia: {
          r: 0,
          x: 0,
          y: 0,
          rx: 0,
          ry: 0
        }
      };
    }
  },
  methods: {
    removePupil(item, index) {
      this.$emit("remove-pupil", item, index);
    },
    cartesianToPolar(x, y) {
      if (x === "--" || y === "--" || x === -1000 || y === -1000) {
        return {
          radius: "--",
          angle: "--", // 弧度
          angleDegrees: "--" // 度数
        };
      }
      // 计算半径 R
      const radius = Math.sqrt(x * x + y * y);
      // 计算角度 θ（弧度）
      let angle = Math.atan2(y, x);

      if (angle < 0) {
        angle += 2 * Math.PI;
      }

      // 如果需要角度（度数）
      const angleDegrees = angle * (180 / Math.PI);
      // 返回极坐标（半径和角度）
      return {
        radius: radius.toFixed(2),
        angle: angle, // 弧度
        angleDegrees: angleDegrees.toFixed(0) // 度数
      };
    },
    getTitile(title) {
      switch (title) {
        case "dark":
          return this.$t("langcfg.txtpupilcorneaDark");
        case "lowerMiddle":
          return this.$t("langcfg.txtpupilcorneaLowerMiddle");
        case "middle":
          return this.$t("langcfg.txtpupilcorneaMiddle");
        case "bright":
          return this.$t("langcfg.txtpupilcorneaBright");
        default:
          return this.$t("langcfg.txtpupilcorneaDark");
      }
    },
    getInfo: function () {},
    getProc() {},
    showlargeImage(item, index) {
      this.largeData.data = item;
      this.largeData.index = index;
      this.isLarge = true;
      this.$bus.$emit("LARGEIMAGE", "open", index);
    },
    closeLargeImage() {
      this.isLarge = false;
      this.$bus.$emit("LARGEIMAGE", "close", this.largeData.index);
    },
    btnDrawToolChange(val) {
      this.graphMode = val;
    },
    onEdgeChanged() {},
    update() {}
  },
  watch: {},
  mounted() {
    this.$bus.$emit("LARGEIMAGE", "closeAll", this.largeData.index);
    this.pupilImageData = objectCopy(this.pupilStaticData);
    this.corneaImageData = objectCopy(this.corneaStaticData);
    this.$bus.$on("CHANGEIMAGEDATA", (data) => {
      this.pupilImageData = data;

      this.largeData.data = this.resData[this.largeData.index];
    });
    this.$bus.$on("PUPILCORNEASELECTCHANGE", (val) => {
      this.isCornea = val === "pupil" ? false : true;
    });
    this.$bus.$on("CHANGECORNEADATA", (data) => {
      this.corneaStaticData.diameter = data;
    });

    this.$bus.$on("CLOSELARGEIMAGE", () => {
      this.isLarge = false;
    });
  },
  destroyed() {
    this.$bus.$off("CHANGEIMAGEDATA");
    this.$bus.$off("PUPILCORNEASELECTCHANGE");
    this.$bus.$off("CHANGECORNEADATA");
    this.$bus.$off("CLOSELARGEIMAGE");
  }
};
</script>

<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/topography/components/PupilCorneaStatic.vue